import React from 'react';
import KickImage from 'Reuseables/KickImage';

/** CSS import */
import Styles from './Blog.module.scss';
import BlogHeader from './Components/Organisms/BlogHeader';
import Banner from './Components/Organisms/Banner';
import Sneakers from './Components/Organisms/Sneakers';
import MarketUpdate from './Components/Organisms/MarketUpdate';
import Fashion from './Components/Organisms/Fashion';
import LatestReleases from './Components/Organisms/LatestReleases';
import Popular from './Components/Organisms/Popular';
import PopularLink from './Components/Organisms/PopularLink';
import Luxury from './Components/Organisms/Luxury';
import UpcomingReleases from './Components/Organisms/UpcomingReleases';
import LatestNews from './Components/Organisms/LatestNews';
import { useHistory } from 'react-router';
import FooterV3 from 'components/PageApp/FooterV3';
import BlogFooter from './Components/Organisms/BlogFooter';
import { useFetchArticleCategories } from './Hooks/useFetchArticleCategories';
import { GetDescriptionContext } from './Context/Description';

const Blog: React.FC = () => {
  const history = useHistory();
  const { getDescriptionBySlug } = useFetchArticleCategories({});

  const latestRef = React.useRef<HTMLDivElement>(null);
  const luxuryRef = React.useRef<HTMLDivElement>(null);
  const popularRef = React.useRef<HTMLDivElement>(null);
  const fashionRef = React.useRef<HTMLDivElement>(null);

  const handleHashUrl = (hash: string) => {
    setTimeout(() => {
      switch (hash) {
        case '#latest':
          latestRef.current?.scrollIntoView({
            behavior: 'smooth',
          });
          break;
        case '#fashion':
          fashionRef.current?.scrollIntoView({
            behavior: 'smooth',
          });
          break;
        case '#popular':
          popularRef.current?.scrollIntoView({
            behavior: 'smooth',
          });
          break;
        case '#luxury':
          luxuryRef.current?.scrollIntoView({
            behavior: 'smooth',
          });
          break;
        default:
          break;
      }
    }, 500);
  };

  React.useEffect(() => {
    const backUrl = localStorage.getItem('kickavenews-back-from-post-listing');

    if (!backUrl) {
      return;
    }

    history.push(backUrl);

    setTimeout(() => {
      localStorage.removeItem('kickavenews-back-from-post-listing');
    }, 500);
  }, []);

  React.useEffect(() => {
    if (history.location.hash === '') {
      return;
    }

    handleHashUrl(history.location.hash);
  }, [history.location.hash]);

  return (
    <div className={Styles['wrapper']}>
      <GetDescriptionContext.Provider value={getDescriptionBySlug}>
        <BlogHeader />
        <div className={Styles['blog-body']}>
          <Banner />
          <Sneakers />
          <MarketUpdate />
          <Fashion ref={fashionRef} />
          <LatestReleases />
          <Popular ref={popularRef} />
          <PopularLink />
          <Luxury ref={luxuryRef} />
          <UpcomingReleases />
          <LatestNews ref={latestRef} />
          <BlogFooter />
        </div>
      </GetDescriptionContext.Provider>
    </div>
  );
};

export default Blog;
